import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance, { axiosFormInstance } from "../../../api/axiosInstance";
import { endpoints } from "../../../api/endpoints";

export const getHiredCandidatesReportRecruiterApi = createAsyncThunk(
  "Client/getHiredCandidatesReportRecruiterApi",
  async (userData, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoints.getlistofreportsforrecruiter,
        userData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const RecruterEarning = createAsyncThunk(
  "Client/RecruterEarning",
  async (userData, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoints.getlistofrecruiterearning,
        userData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const getHiredCandidatesReportRecruiterApiSlice = createSlice({
  name: "getHiredCandidatesReportRecruiterApiSlice",
  initialState: {
    data: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHiredCandidatesReportRecruiterApi.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })

      .addCase(
        getHiredCandidatesReportRecruiterApi.fulfilled,
        (state, action) => {
          state.status = "succeeded";
          state.data = action.payload;
        }
      )

      .addCase(
        getHiredCandidatesReportRecruiterApi.rejected,
        (state, action) => {
          state.status = "failed";
          state.error = action.payload;
        }
      )

      .addCase(RecruterEarning.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })

      .addCase(RecruterEarning.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(RecruterEarning.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});
export default getHiredCandidatesReportRecruiterApiSlice.reducer;
